import { jsx as _jsx } from "react/jsx-runtime";
import { getLoadingTransitionStyle } from '#pplx/frontend/aether/components/Button/loadingTransitionStyle.js';
import { Spinner } from '#pplx/frontend/aether/components/Spinner/index.js';
/**
 * Maps button sizes to spinner sizes in pixels.
 * These sizes match the icon sizes for visual consistency.
 */
const BUTTON_SIZE_TO_SPINNER_SIZE = {
    large: 24,
    default: 20,
    small: 16,
    tiny: 14,
};
/**
 * Returns the appropriate spinner color based on button variant.
 * Primary buttons inherit the button's text-inverse color, others use default.
 */
function getSpinnerColor(variant) {
    // For primary buttons, don't set a color - let it inherit text-inverse
    // For other variants, use default which inherits the current text color
    return variant === 'primary' ? undefined : 'default';
}
/**
 * Internal component that renders a loading spinner overlay.
 * Uses absolute positioning to overlay the spinner without affecting layout.
 * Includes sequential fade: fades in with delay when visible, fades out immediately when hidden.
 */
export function LoadingOverlay({ size, variant, isVisible }) {
    const spinnerColor = getSpinnerColor(variant);
    return (_jsx("div", { style: getLoadingTransitionStyle(isVisible), className: "absolute inset-0 flex items-center justify-center", children: isVisible && _jsx(Spinner, { size: BUTTON_SIZE_TO_SPINNER_SIZE[size], color: spinnerColor }) }));
}
//# sourceMappingURL=LoadingOverlay.js.map